<template>
  <div class="quiz">
    <div v-if="started===false && isAnswered==false" class="container-1">
      <img class="quiz-img" src="../assets/EKS-Score.svg">
      <img id="trenner_lang" src="../assets/linie-vertikal.svg" title="Trenner" alt="Trenner" class="trenner_lang">

      <template>
        <button class="answer" @click="started=new Date()" v-html="content.ueberschrift" />
      </template>
    </div>

    <div v-if="(started===false && isAnswered==true) || (started!==false)" class="container-1">
      <img class="quiz-img" src="../assets/EKS-Score.svg">
      <img id="trenner_lang" src="../assets/linie-vertikal.svg" title="Trenner" alt="Trenner" class="trenner_lang">

      <template><button class="fake" v-html="content.ueberschrift" /></template>
    </div>
    <div v-if="started===false && isAnswered==true" class="container-2">
      <div class="subpart"><i>{{ content.ueberschriftsolvedquiz }}</i></div>
    </div>

    <div v-if="started!==false" class="container-3">
      <template>
        <h2 v-if="hideQuestion===false"> {{ question[language].Frage }} </h2>

        <button v-for="b,index in question[language].Antworten"
                v-if="hideQuestion===false && b.length>0"
                class="answerpossibilities"
                :class="{highlight:index == answerednumber}"
                @click="answered(index)"
        >
          {{ b }}
        </button>
      </template>

      <span class="status">
        <img v-if="statusiconRichtig" class="statusIcon" src="../assets/EKS-smiley-happy.svg">
        <img v-if="statusiconFalsch" class="statusIcon" src="../assets/EKS-smiley-sad.svg">
        {{ status }}
      </span>
    </div>
  </div>
</template>

<script type="text/babel">

export default {
  name: 'Quiz',
  props: {
    questions: Array,
    waypointid: String,
  },
  data() {
    return {
      status: '',
      statusiconRichtig: false,
      statusiconFalsch: false,
      question: {},
      started: false,
      hideQuestion: false,
      showRightAnswer: false,
      answerednumber: Object,
    }
  },
  computed: {
    language: function () {
      return this.$root.$i18n.locale
    },
    isAnswered: function () {
      let foundIndex = this.$root.solvedQuizes.findIndex(x => x.id == this.waypointid)
      return foundIndex >= 0
    },
    content: function () {
      return this.$root.quizcontent[this.language]
    },
  },
  watch: {
    questions: function () {
      this.resetValues()
      this.question = this.questions[Math.floor(Math.random() * this.questions.length)]
    },
  },
  mounted() {
    this.question = this.questions[Math.floor(Math.random() * this.questions.length)]
    //console.log(this.questions)
    //console.log(this.question)
  },
  methods: {
    resetValues: function () {
      this.status = ''
      this.statusiconRichtig = false
      this.statusiconFalsch = false
      this.question = {}
      this.started = false
      this.hideQuestion = false
      this.showRightAnswer = false
      this.answerednumber = Object
    },
    answered: function (index) {
      //console.log('Pressed ' + index);

      if (this.answerednumber > 0) return

      this.answerednumber = index

      let foundIndex = this.$root.solvedQuizes.findIndex(x => x.id == this.waypointid)

      if (this.answerednumber == parseInt(this.question.Antwort)) {
        // alert('RICHTIG!');
        this.status = this.content.quizcorrect
        this.statusiconRichtig = true

        let wpitem = {
          id: this.waypointid,
          answerRight: true,
          startDate: this.started,
          endDate: new Date(),
        }

        if (foundIndex >= 0) {
          this.$set(this.$root.solvedQuizes, foundIndex, wpitem)

          //this.$root.solvedQuizes[foundIndex] = wpitem;
        } else {
          this.$root.solvedQuizes.push(wpitem)
        }
      } else {
        //alert('Leider falsch');
        this.status = this.content.quizincorrect
        this.statusiconFalsch = true
        let wpitem = {
          id: this.waypointid,
          answerRight: false,
          startDate: this.started,
          endDate: new Date(),
        }

        if (foundIndex >= 0) {
          this.$set(this.$root.solvedQuizes, foundIndex, wpitem)

          //qsolved[foundIndex] = wpitem;
        } else {
          this.$root.solvedQuizes.push(wpitem)
        }

      }

      // this.hideQuestion = true;
      this.showRightAnswer = true
    },
  },
}
</script>

<style scoped lang="scss">
.trenner_lang {
  max-width: 1px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 4px;

  @media screen and (max-width: 480px) {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 3px;
    height: 20px;
  }
}
.haken {
  color: green;
}

.kreuz {
  color: red;
}

h1 {
  text-align: center;
  font-size: 22px;
  line-height: 24px;
  margin-bottom: 20px;
}

h2 {
  font-size: 30px;
  margin-bottom: 20px;
  font-weight: bold;
  color: white;
  text-transform: none;

  @media screen and (max-width: 480px) {
    font-size: 24px;
    margin-bottom: 10px;
  }
}

.quiz {
  text-align: left;
  background-color: #350f37;
  margin-bottom: 40px;
  box-sizing: border-box;
  color: #fff;
  font-size: 24px;
  line-height: 1.1;
  font-weight: bold;
  font-family: 'Source Sans Pro', sans-serif;
  display: block;

  .container-1,
  .container-2,
  .container-3
  {
    padding: 20px 40px;
    box-sizing: border-box;

    @media screen and (max-width: 480px) {
      padding: 10px 20px;
    }
  }
  .container-2 {
    background-color: #49274a;
  }
  .container-3 {
    background-color: #49274a;
    padding: 60px 40px;

    @media screen and (max-width: 480px) {
      padding: 30px 20px;
    }
  }

  .quiz-img {
    width: 50px;

    @media screen and (max-width: 480px) {
      width: 30px;
    }
  }

  .subpart {
    display: block;
    font-weight: normal;
  }
}

button.answer,
button.fake
{
  padding-bottom: 10px;
  box-sizing: border-box;
  border-radius: 0;
  width: auto;
  max-width: 400px;
  display: inline-block;
  border: none;
  background-color: transparent;
  color: #fff;
  font-size: 24px;
  line-height: 1.1;
  cursor: pointer;
  font-weight: bold;
  font-family: 'Source Sans Pro', sans-serif;
  text-align: left;

  @media screen and (max-width: 480px) {
    padding-bottom: 3px;
    font-size: 20px;
  }
  @media screen and (max-width: 360px) {
    padding-bottom: 4px;
    font-size: 16px;
  }
}
button.fake
{
  cursor: default;
}
button.answerpossibilities {
  display: block;
  color: #350f37;
  background-color: white;
  border: 3px solid #b3905a;
  border-radius: 10px;
  text-transform: none;
  font-size: 24px;
  line-height: 1.1;
  font-weight: bold;
  font-family: 'Source Sans Pro', sans-serif;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 30px;
  cursor: pointer;

  @media screen and (max-width: 480px) {
    padding: 10px;
    font-size: 20px;
  }
}
button.answerpossibilities:hover,
button.answerpossibilities.highlight
{
  background-color: #b3905a;
  color: white;
}

.status {
  font-size: 24px;
  line-height: 1.1;
  display: flex;
  flex-direction: row;
  align-items: center;

  .statusIcon {
    width: 60px;
    margin-right: 20px;
  }
}
</style>
